import {
  CHECK_NEW_MESSAGES,
  CheckNewMessagesAction,
} from '../types/redux/actions';

export function checkNewMessagesSuccess(
  data: boolean,
): CheckNewMessagesAction {
  return {
    type: CHECK_NEW_MESSAGES,
    payload: data,
  };
}
